import React, { Component, ReactNode } from 'react';
import * as Sentry from '@sentry/browser';
import { FormattedMessage } from 'react-intl';
import messages from '../../i18n/src/messages.ts';

interface ErrorBoundaryProps {
    children?: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

// This must stay as a class component. No hook exists for the equivalent componentDidCatch method.
class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(err: Error): void {
        this.setState({ hasError: true });
        Sentry.captureException(err);
    }

    render(): ReactNode {
        if (this.state.hasError) {
            const wrapperStyle: React.CSSProperties = {
                textAlign: 'center',
                marginTop: '7.692rem',
            };
            const titleStyle: React.CSSProperties = {
                fontSize: '2.308rem',
            };
            const introStyle: React.CSSProperties = {
                fontSize: '1.538rem',
            };

            return (
                <div style={wrapperStyle}>
                    <p style={titleStyle}>
                        <FormattedMessage
                            {...messages['error.boundary.title']}
                        />
                    </p>
                    <p style={introStyle}>
                        <FormattedMessage
                            {...messages['error.boundary.intro']}
                        />
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;